import React from 'react';
import ButtonClose from './ButtonClose/ButtonClose';
import ChatContainerQuickReply from './ChatContainerQuickReply/ChatContainerQuickReply';
import ChatContent from './ChatContent/ChatContent';
import DarkMode from './DarkMode/DarkMode';
import Storm from './Storm/Storm';
import ButtonFocus from './ButtonFocus/ButtonFocus';
import ButtonVariable from './ButtonVariable/ButtonVariable';
import ButtonSound from './ButtonSound/ButtonSound';
import ButtonReset from './ButtonReset/ButtonReset';
import ButtonPath from './ButtonPath/ButtonPath';
import LoaderDebugChatbox from './LoaderDebugChatbox/LoaderDebugChatbox';
const ChatBoxChat = ({ mode}) => {
    return (
        <div className="kwalys-chat">
            <ButtonClose/>
            <ButtonReset/>
            { mode == 'debug' ? <ButtonPath/> : null}
            <ButtonSound/>
            
            { mode == 'debug' ? <ButtonFocus/> : null}
            { mode == 'debug' ? <ButtonVariable/> : null}
            <Storm/>
            <LoaderDebugChatbox/>
            <ChatContent/>
            <ChatContainerQuickReply/>
        </div>
    );
};

export default ChatBoxChat;